import { RootState } from '../../rootReducer'

export const modalAddFieldsVisible = (state: RootState) => state.modalAddFields.isVisible
export const modalAddFieldsData = (state: RootState) => state.modalAddFields.data
